export default "__VITE_ASSET__4b1083fc__"